import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { eventName: String }

  trigger(event) {
    document.dispatchEvent(new CustomEvent(this.eventNameValue, { detail: event }))
  }
}
